module.exports = __webpack_public_path__ + "static/media/cbs-tv-search-mid.f811b24c.png";